// @flow

import { observer } from "mobx-react";
import React from "react";

import GlobalSettings from "app/stores/GlobalSettingsStore";

import User from "app/models/User";
import Video from "app/models/Video";

import Panel from "app/components/Panel/Panel";
import UserThumbnail from "app/components/UserThumbnail/UserThumbnail";
import VideoCards from "app/components/VideoCards/VideoCards";

import "./UserProfileView.scss";

type Props = {
    user: User,
    videos: Video[],
    serverTime: any
};

@observer
export default class UserProfileView extends React.Component<Props> {
    user: User;
    videos: Video[];

    constructor(props: Props) {
        super(props);

        const user = User.make(this.props.user);
        if (!user) throw Error("User not authenticated");

        this.user = user;
        this.videos = Video.makeArray(this.props.videos);
    }

    render() {
        return (
            <div className="UserProfileView">
                <div className="container">
                    {this.renderUserInfo()}
                    {this.renderVideos()}
                </div>
            </div>
        );
    }

    renderUserInfo() {
        return (
            <div className="UserProfileView__user">
                <Panel>
                    <div className="UserProfileView__user-photo">
                        <UserThumbnail
                            name={this.user.displayName}
                            image={this.user.profile_image}
                        />
                    </div>
                    <div className="UserProfileView__user-info">
                        <h2 className="UserProfileView__user-name">
                            {this.user.displayName}
                        </h2>
                        <p className="UserProfileView__user-total-videos">
                            {this.renderTotalVideos()}
                        </p>
                    </div>
                </Panel>
            </div>
        );
    }

    renderTotalVideos() {
        const total = this.props.videos.length;
        if (total === 1) {
            return total + " video";
        }
        return total + " videos";
    }

    renderVideos() {
        return (
            <div className="UserProfileView__videos">
                <VideoCards
                    isDashboard={false}
                    showUnplublishWarning={false}
                    videos={this.videos}
                    serverTime={this.props.serverTime}
                    theme={GlobalSettings.videoCardTheme}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/views/app/user/UserProfile/UserProfileView.js